import fr from './fr.json'
import en from './en.json'
import es from './es.json'
import de from './de.json'
import it from './it.json'
import pt from './pt.json'

export default {
    fr,
    en,
    es,
    de,
    it,
    pt
}